import { twMerge } from 'tailwind-merge';

import * as NetworkCard from '@/components/Network/NetworkCard';

export type NetworksGridProps = {
  networks?: AdaptedNetwork[];
  className?: string;
};

export function NetworksGrid({ networks, className }: NetworksGridProps) {
  return (
    <div
      className={twMerge(
        'mt-20 grid w-full items-center justify-items-center',
        'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4',
        'gap-12 lg:gap-x-10 lg:gap-y-20',
        className,
      )}
    >
      {networks?.map(network => {
        return (
          <NetworkCard.Root
            key={network.id}
            network={network}
            className="max-w-xs"
          >
            <NetworkCard.TitleImage />

            <NetworkCard.Content>
              <NetworkCard.Info>
                <NetworkCard.Name />
              </NetworkCard.Info>
            </NetworkCard.Content>
          </NetworkCard.Root>
        );
      })}
    </div>
  );
}
